import { useNavigate } from '@tanstack/react-router';
import { parseCellCode, type CellCardDto } from '@eombor/contracts';
import { isScannerClaimed } from '../../shared/scanner/scanner-claim.js';
import { useScannerDialog } from '../../shared/scanner/scanner-dialog.store.js';
import { useBarcodeScanner } from '../../shared/scanner/useBarcodeScanner.js';
import { CellScanDialog } from '../../features/warehouse/ui/CellScanDialog.js';
import { cellCardPath } from '../routes/warehouses.js';

/**
 * UMUMIY SKANER — butun qobiq bo'ylab.
 *
 * Nega qobiqda: skladchi javon oldida turadi va qo'lida skaner bor. U qaysi
 * ekranda ekanini o'ylab o'tirmaydi — etiketkani o'qiydi va oyna O'ZI ochilib,
 * kodni ko'rsatadi. "Avval Ombor bo'limiga o'ting, keyin tugma bosing" degan
 * talab skanerning butun ma'nosini yo'qotardi.
 *
 * Nega tinglovchi va oyna AJRALGAN: oyna ochiq bo'lmaganda ham kod kelishi
 * mumkin — aynan o'sha kod oynani ochadi. Tinglovchi shuning uchun oynadan
 * tashqarida, doimiy turadi.
 *
 * BAND QILISH — eng muhim qism. Talabnoma berish oqimi TALABNOMA raqamini
 * kutadi, kirim hujjati esa katak kodini O'Z satriga yozadi. Ular skanerni
 * band qiladi va bu tinglovchi o'sha paytda jim turadi.
 *
 * Kirish sahifasi qobiqdan TASHQARIDA — parol yozayotgan odamning tugmalari
 * bu yerga umuman yetib kelmaydi.
 */
export const GlobalScanner = () => {
  const navigate = useNavigate();
  const { open, code, openScanner, closeScanner } = useScannerDialog();

  useBarcodeScanner((scanned) => {
    // Ekran skanerni band qilgan bo'lsa — bu kod bizga emas.
    if (isScannerClaimed()) return;
    /*
     * FAQAT KATAK KODI.
     *
     * Ilgari bu yerga HAR QANDAY o'qilgan matn tushardi va oyna
     * ochilaverardi: skladchi qutidagi partiya etiketkasini yoki
     * butunlay begona shtrix-kodni skanerlasa ham, ekranda «bunday
     * katak topilmadi» degan oyna chiqardi. Ya'ni qurilma butun tizim
     * bo'ylab ishlab, hech qayerda kerak bo'lmagan javob berardi.
     *
     * Endi umumiy tinglovchi faqat JAVON YORLIG'INI taniydi
     * (`A-03-02-05`). Qolgan kodlar o'z ekraniga tegishli va o'sha
     * ekran skanerni band qilganda ishlaydi (`claimScanner`) —
     * berish, kirim va qabul oqimlari shunday.
     */
    if (parseCellCode(scanned.trim().toUpperCase()) === null) return;
    openScanner(scanned);
  });

  const openCell = (cell: CellCardDto): void => {
    void navigate({ to: cellCardPath(cell.warehouseId, cell.code) });
  };

  return (
    <CellScanDialog open={open} onClose={closeScanner} initialCode={code} onOpenCell={openCell} />
  );
};
